import { atom, useAtom } from 'jotai/index';
import { getUserSessionData } from '../utils/getUserSessionData.ts';

const addressAtom = atom<string | null>(getUserSessionData());

export const useAddress = () => useAtom(addressAtom);

